import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectAddresses, selectSelectedAddressId } from '../api/redux/addressSlice';
import { resolveAreaCityForServicesApi } from '../utils/serviceArea';
import { useLocationAreaCity } from './useLocationAreaCity';

/** Resolved `area_city` for customer catalog APIs (address district/city, then GPS). */
export function useServiceAreaCity(): string | undefined {
  const addresses = useSelector(selectAddresses);
  const selectedAddressId = useSelector(selectSelectedAddressId);
  const locationAreaCity = useLocationAreaCity();
  return useMemo(
    () => resolveAreaCityForServicesApi(addresses, selectedAddressId, locationAreaCity),
    [addresses, selectedAddressId, locationAreaCity]
  );
}
